import { faKey, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from 'react-router';
import { useHackathon } from '../../hooks/useHackathon';
import AppToolbar from '../shared/AppToolbar';
import DismissableMessage from '../shared/DismissableMessage';
import { Page, PageBody, PageTitle } from '../shared/Layout';
import Require from '../shared/Require';
import { HackathonStageEditor } from './HackathonStageEditor';
import { DemoSlotEditor } from './DemoSlotEditor';
import { DemoSlotProvider } from '../../hooks/useDemoSlot';
import { ButtonLink } from '../shared/Button';
import styled from '@emotion/styled';

type RouteParams = { hackathonId?: string };

export const AdminHome: FC<RouteComponentProps<RouteParams>> = ({ match }) => {
  const parsedId = match.params.hackathonId ? parseInt(match.params.hackathonId, 10) : undefined;
  const hackathonId = parsedId && !isNaN(parsedId) ? parsedId : undefined;
  const { hackathon, setStage } = useHackathon(hackathonId);

  return (
    <>
      <Helmet>
        <title>Admin</title>
      </Helmet>
      <Page>
        <AppToolbar hackathonId={hackathon ? hackathon.hackathonId : undefined} />
        <PageBody>
          <Require required={hackathon}>
            {() => (
              <>
                <BackButtonLink to="/admin" size="sm">
                  <FontAwesomeIcon icon={faArrowLeft} /> Back to Hackathon List
                </BackButtonLink>
                <TitleContainer>
                  <PageTitle>{hackathon!.name} Admin</PageTitle>
                </TitleContainer>
                <DismissableMessage messageKey="admin:welcome" icon={<FontAwesomeIcon icon={faKey} />}>
                  Welcome, <strong>admin</strong>. Be careful where you tread. Here be dragons (and very little testing)
                </DismissableMessage>
                <HackathonStageEditor currentStage={hackathon!.currentStage} setStage={setStage} />
                <DemoSlotProvider hackathonId={hackathon!.hackathonId}>
                  <DemoSlotEditor hackathonId={hackathon!.hackathonId} />
                </DemoSlotProvider>
              </>
            )}
          </Require>
        </PageBody>
      </Page>
    </>
  );
};

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

const BackButtonLink = styled(ButtonLink)`
  margin-bottom: 12px;
  font-size: 12px;
  align-self: flex-start;
`;
